import React from 'react';
import type { IconProps } from './IconPlus';

export const IconCircleCheck: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="10" cy="10" r="8.5" stroke={color} strokeWidth="1.5" />
    <path d="M6.5 10.5L9 13L13.5 8.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

